import dayjs from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import isoWeek from 'dayjs/plugin/isoWeek'

dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(isoWeek)

export const getDefaultDateRange = (): [Date, Date] => {
  const today = new Date()
  const sevenDaysAgo = new Date()
  sevenDaysAgo.setDate(today.getDate() - 7)
  return [sevenDaysAgo, today]
}

export const formatDateRange = (startDate: Date, endDate: Date): string => {
  const start = dayjs(startDate).format('DD/MM/YYYY')
  const end = dayjs(endDate).format('DD/MM/YYYY')
  return `${start} - ${end}`
}

export const getWeekRangeString = (weekNumber: string): string => {
  const currentYear = new Date().getFullYear()
  const startOfWeek = dayjs().year(currentYear).week(parseInt(weekNumber)).startOf('week')
  const endOfWeek = startOfWeek.clone().endOf('week')
  return `${startOfWeek.format('D/MM')} - ${endOfWeek.format('D/MM')}`
}

export const formatDateForAPI = (date: Date): string => {
  return dayjs(date).format('YYYY-MM-DD')
}
